import { createContext } from 'react';
export const FilePickerRuntimeContext = createContext(null);
FilePickerRuntimeContext.displayName = 'FilePickerRuntimeContext';
//# sourceMappingURL=FilePickerContext.js.map